module.exports = __webpack_public_path__ + "static/media/Fifty.e76c78e3.ogg";